export default "__VITE_ASSET__C0Egin2x__"